import { Directive, TemplateRef } from '@angular/core';

/**
 * Only used to inject templates and know what it is intended to replace
 */
@Directive({ selector: '[ui-list-header-template]' })
export class UIListHeaderTemplateDirective {
    constructor(public template: TemplateRef<any>) {}
}
